import _typeof from "@babel/runtime/helpers/typeof";
export var isRedirectionEnabled = function isRedirectionEnabled(feature) {
  if (_typeof(feature) === 'object') {
    return 'enable-redirection' in feature;
  }
  if (typeof feature === 'string') {
    try {
      var parsedFeature = JSON.parse(feature);
      return parsedFeature && _typeof(parsedFeature) === 'object' && 'enable-redirection' in parsedFeature;
    } catch (error) {
      return false;
    }
  }
  return false;
};
export var getCrossSiteTenantIdFromAllowedFeature = function getCrossSiteTenantIdFromAllowedFeature(feature) {
  var _feature$enableRedir;
  if (!feature) {
    return undefined;
  }
  if (typeof feature === 'string') {
    try {
      var _parsed$enableRedire;
      var parsed = JSON.parse(feature);
      return (_parsed$enableRedire = parsed['enable-redirection']) === null || _parsed$enableRedire === void 0 ? void 0 : _parsed$enableRedire['cross-site-tenant-id'];
    } catch (error) {
      return undefined;
    }
  }
  return (_feature$enableRedir = feature['enable-redirection']) === null || _feature$enableRedir === void 0 ? void 0 : _feature$enableRedir['cross-site-tenant-id'];
};